import React from "react";
import styled from "styled-components";
import NewsPageWrapper from "../components/NewsPageWrapper";
import CopyToCliboardButton from "../components/CopyToClipboardButton";
import moment from "moment";

const NewsWrapper = styled.div`
  position: relative;
  background: ${(props) => props.theme.colors.secondary03};
  padding: 16px 16px 32px 16px;
  border-radius: ${(props) => props.theme.borders.radius01};
`;

const NewsHeader = styled.div`
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary02};
`;

const PublicationWrapper = styled.div`
  font-size: 10px;
  padding-top: 8px;
  position: absolute;
  display: inline-block;
  right: 16px;
  color: ${(props) => props.theme.colors.primary02};
`;

const NewsDescription = styled.div`
  padding: 8px 0 0 0;
  word-break: break-word;
`;

const EditorName = styled.div`
  position: relative;
  display: inline-block;
  left: 10px;
  top: -18px;
`;

const EditorImage = styled.img`
  border-radius: 100%;
  object-fit: cover;
  width: 45px;
  height: 45px;
  border: 2px solid ${(props) => props.theme.colors.primary};
`;

export default ({ authorName, authorPicurl, date, content }) => {
  const formattedDate = moment.unix(date).format("DD.MM.YYYY - HH:mm [Uhr]");
  const strippedContent = content.replace(/(<([^>]+)>)/gi, "");
  return (
    <NewsPageWrapper>
      <NewsWrapper>
        <CopyToCliboardButton
          text={`${authorName} (${formattedDate}):
${strippedContent}`}
        />
        <NewsHeader>
          <EditorImage src={authorPicurl} alt="Profilbild" />
          <EditorName>{authorName}</EditorName>
        </NewsHeader>
        <NewsDescription dangerouslySetInnerHTML={{ __html: content }} />
        <PublicationWrapper>{formattedDate}</PublicationWrapper>
      </NewsWrapper>
    </NewsPageWrapper>
  );
};
